import { render, staticRenderFns } from "./CustomerBill.vue?vue&type=template&id=c428ec6c&scoped=true&"
import script from "./CustomerBill.vue?vue&type=script&lang=js&"
export * from "./CustomerBill.vue?vue&type=script&lang=js&"
import style0 from "./CustomerBill.vue?vue&type=style&index=0&id=c428ec6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c428ec6c",
  null
  
)

export default component.exports